/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function BrainIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="brain"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M12 6L12 5.803C12 5.279 12.155 4.768 12.445 4.332L12.45 4.325C13.292 3.062 15.021 2.766 16.235 3.676C17.257 4.443 17.585 5.83 17.013 6.973L17 7" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M17 7C18.035 5.965 19.757 6.136 20.569 7.353L20.602 7.403C20.862 7.792 21 8.249 21 8.717L21 9C21 10.657 19.657 12 18 12" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 18L12 18.197C12 18.721 12.155 19.232 12.445 19.668L12.45 19.675C13.292 20.938 15.021 21.234 16.235 20.324C17.257 19.557 17.585 18.17 17.013 17.027L17 17" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M17 17C18.035 18.035 19.757 17.864 20.569 16.647L20.602 16.597C20.862 16.208 21 15.751 21 15.283L21 15C21 13.343 19.657 12 18 12" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 18L12 5.803C12 5.279 11.845 4.768 11.555 4.332L11.55 4.325C10.708 3.062 8.979 2.766 7.765 3.676C6.743 4.443 6.415 5.83 6.987 6.973L7 7" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M7 7C5.965 5.965 4.243 6.136 3.431 7.353L3.398 7.403C3.138 7.792 3 8.249 3 8.717L3 9C3 10.657 4.343 12 6 12" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 18L12 18.197C12 18.721 11.845 19.232 11.555 19.668L11.55 19.675C10.708 20.938 8.979 21.234 7.765 20.324C6.743 19.557 6.415 18.17 6.987 17.027L7 17" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M7 17C5.965 18.035 4.243 17.864 3.431 16.647L3.398 16.597C3.138 16.208 3 15.751 3 15.283L3 15C3 13.343 4.343 12 6 12" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 16L12 13C12 11.343 13.343 10 15 10" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 19L12 17C12 15.343 10.657 14 9 14" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
